import { useState } from 'react';

interface PopupState {
  isOpen: boolean;
  message: string;
  type: 'success' | 'error';
}

export const useStripePopup = () => {
  const [popup, setPopup] = useState<PopupState>({
    isOpen: false,
    message: '',
    type: 'error'
  });

  const showPopup = (message: string, type: 'success' | 'error' = 'error') => {
    setPopup({
      isOpen: true,
      message,
      type
    });
  };

  const hidePopup = () => {
    setPopup(prev => ({
      ...prev,
      isOpen: false
    }));
  };

  return {
    popup,
    showPopup,
    hidePopup
  };
};